var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v("Average TicketBy Time")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.exportTicket($event)
                }
              }
            },
            [_vm._v("Export")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "card" }, [
            _c("h5", { staticClass: "card-header" }, [
              _c("div", {}, [
                _c("div", { staticClass: "two-filter" }, [
                  _c(
                    "div",
                    { staticClass: "selectbox1" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "user",
                          placeholder: "Type name here",
                          label: "name",
                          options: _vm.userOptions
                        },
                        model: {
                          value: _vm.selectedUser,
                          callback: function($$v) {
                            _vm.selectedUser = $$v
                          },
                          expression: "selectedUser"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "selectbox1" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "location",
                          placeholder: "Type location here",
                          label: "location_name",
                          options: _vm.locationOptions
                        },
                        model: {
                          value: _vm.selectedLocation,
                          callback: function($$v) {
                            _vm.selectedLocation = $$v
                          },
                          expression: "selectedLocation"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "selectbtn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-warning applybtn",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.loadTicketAvgTime()
                        }
                      }
                    },
                    [_vm._v("Apply Filter")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary clearbtn",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.clearFileter()
                        }
                      }
                    },
                    [_vm._v("Clear Filter")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("vue-good-table", {
                  attrs: {
                    columns: _vm.columns,
                    rows: _vm.rows,
                    "line-numbers": true,
                    searchOptions: {
                      enabled: true,
                      placeholder: "Search by Name"
                    },
                    "pagination-options": {
                      enabled: true,
                      mode: "pages"
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e205ca2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e205ca2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AvgTicketTime.vue
// module id = null
// module chunks = 